import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAutoLogout = () => {
  const timeoutRef = useRef(null);
  const cleanupRef = useRef(null); // храним функцию очистки
  const navigate = useNavigate();

  const startAutoLogout = (timeout, onLogout) => {
    // вызываем предыдущую очистку, если была
    if (cleanupRef.current) {
      cleanupRef.current();
    }

    const resetTimer = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        onLogout();
        navigate('/login');
      }, timeout);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        resetTimer();
      }
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    document.addEventListener('visibilitychange', handleVisibilityChange);

    resetTimer();

    // сохраняем функцию очистки в ref
    cleanupRef.current = () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    // и возвращаем эту же функцию для возможного использования в useEffect
    return cleanupRef.current;
  };

  return { startAutoLogout };
};
